import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import axiosClient from 'http/axios-client';
import { jsPDF } from 'jspdf';
import * as XLSX from 'xlsx';
import { useQuery } from 'react-query';
import { limitConcurrency } from 'hooks/utils';
import * as moment from 'moment';
import MonthSelector from 'components/basic/MonthSelector';
import { Switch, Typography } from '@material-ui/core';
import CountrySelector from 'components/basic/CountrySelector';
import { LoadingButtonNoGrid as LoadingButton, LoadingButtonNoGrid } from '../../basic/LoadingButton';
import './LiberationSerif-Regular-normal';
import { filterTypes } from '../../basic/AdvancedFilters';
import AppTable from '../../basic/AppTable';
import AppLoader from '../../basic/AppLoader';
import { useItems } from '../../../hooks/atoms/items-hook';
import CollectionKeys from '../../../hooks/molecules/collection-keys';

export const wellnessAnswersMapping = {
  wl_answer_3_1: 'Yes',
  wl_answer_3_2: 'No',
  wl_answer_5_1: 'Diet for weight loss',
  wl_answer_5_2: 'Diet for weight gain',
  wl_answer_5_3: 'Diet for weight maintenance',
  wl_answer_5_4: 'Pregnancy nutrition',
  wl_answer_5_5: 'Nutrition during breastfeeding',
  wl_answer_5_6: 'Sports nutrition',
  wl_answer_5_7: 'Nutritional management of metabolic syndrome',
  wl_answer_5_8: 'Nutritional management of cardiovascular diseases (hypertension, dyslipidemia, atherosclerosis, coronary heart disease, heart attack, etc.)',
  wl_answer_5_9: 'Nutritional management of type 2 diabetes mellitus',
  wl_answer_6_1: 'I have no known medical history',
  wl_answer_6_2: 'Kidney disease',
  wl_answer_6_3: 'Diabetes Mellitus',
  wl_answer_6_4: 'Iron deficiency anemia (low iron)',
  wl_answer_6_5: 'Cardiovascular',
  wl_answer_6_6: 'Hypercholesterolemia',
  wl_answer_6_7: 'Megaloblastic anemia (low B9, B12)',
  wl_answer_6_8: 'Hypertension',
  wl_answer_6_9: 'Digestive diseases, please specify',
  wl_answer_6_10: 'Other, please specify',
  wl_answer_7_1: 'I am not taking any medication',
  wl_answer_7_2: 'Antihypertensives',
  wl_answer_7_3: 'Statins or other medications for high cholesterol',
  wl_answer_7_4: 'Antidiabetic drugs',
  wl_answer_7_5: 'Other, please specify',
  wl_answer_8_1: 'I do not take any dietary supplements.',
  wl_answer_8_2: 'Multivitamin preparation',
  wl_answer_8_3: 'Vitamin A',
  wl_answer_8_4: 'Vitamin C',
  wl_answer_8_5: 'Vitamin D',
  wl_answer_8_6: 'Vitamin Ε',
  wl_answer_8_7: 'Complex B',
  wl_answer_8_8: 'Calcium',
  wl_answer_8_9: 'Iron',
  wl_answer_8_10: 'Magnesium',
  wl_answer_8_11: 'Omega-3 fats/cod liver oil',
  wl_answer_8_12: 'Coenzyme Q-10',
  wl_answer_8_13: 'Other, please specify',
};

export const getConsentValue = (consent, kit) => {
  let status = '';

  const val = kit.agreements.find((aggr) => {
    return aggr.consent.name === consent.name;
  });

  if (val == null) { status = ''; } else {
    status = val.status === true ? 'YES' : 'NO';
  }

  if (status === '' && kit.registrationStatus !== 'sample_pending' && kit.created_at < '2023-06-01T12:08:22.000Z') {
    if (consent.name === 'RESEARCH') {
      return 'N/A';
    }

    if (kit.thematic_package?.thematic_category_id?.name === 'PGx') {
      if (consent.name === 'PGX_GENERAL_CONSENT' || consent.name === 'PHARMACOGENETIC_ANALYSIS_CONSENT') {
        return 'N/A';
      }

      return status;
    }

    if (consent.name === 'PROMOTION') {
      return 'N/A';
    }

    if (kit.thematic_package?.thematic_category_id?.name === 'Biological Age') {
      if (consent.name === 'BIOLOGICAL_AGE_GENERAL_CONSENT' || consent.name === 'BIO_DATA_CONSENT') {
        return 'N/A';
      }

      return status;
    }

    if (consent.name === 'NUTRIGENETIX_CARDIO_WELLNESS_GENERAL_CONSENT' || consent.name === 'GENETIC_ANALYSIS_CONSENT') {
      return 'N/A';
    }
  }

  return status;
};

export const parseDate = (date) => {
  let deepSelectorValue = date;
  if (deepSelectorValue != null && deepSelectorValue !== '') {
    if (deepSelectorValue.length < 10) {
      return deepSelectorValue;
    }
    if (deepSelectorValue.length !== 10) {
      deepSelectorValue = deepSelectorValue.substring(0, deepSelectorValue.indexOf('T'));
    }
    deepSelectorValue = deepSelectorValue.split('-');
    deepSelectorValue = `${ deepSelectorValue[2] }/${ deepSelectorValue[1] }/${ deepSelectorValue[0] }`;
  }

  return deepSelectorValue || '';
};

export const PDFCreationFromDBOrAmazon = ({ kit }) => {
  let data;
  let isLoading;

  try {
    ({ data, isLoading } = useQuery([ 'aws', 'kit', JSON.stringify(kit) ?? '' ], () => {
      if (kit == null || kit.serial_number_id == null) {
        return null;
      }

      let pdfCreation = parseDate(kit.pdf_creation);
      if (pdfCreation === '' || pdfCreation == null) {
        pdfCreation = parseDate(kit.pdf_received_date);
      }

      try {
        if (kit.serial_number_id.serial != null && kit.pdf_available && (pdfCreation == null || pdfCreation === '')) {
          return axiosClient.get(`/registration-kits/aws-bucket/?serial=${ kit.serial_number_id.serial }.pdf`).then((dd) => {
            return parseDate(dd.LastModified);
          }).catch((err) => {
            console.error(err);
          });
        }
      } catch (e) {
        console.error(e);
        return '';
      }

      return pdfCreation;
    }));
  } catch (e) {
    console.error(e);
  }

  if (isLoading) {
    return null;
  }

  return (
    <>
      {
        data
      }
    </>
  );
};

// sample_pending
// registration_done
// sample_received
// analysis
// done

export const getFullRegistrationStatus = (kit) => {
  function capitalize(s) {
    return s && s[0].toUpperCase() + s.slice(1);
  }

  const status = kit?.registrationStatus;

  if (status == null || status === '') {
    return '';
  }

  if (status === 'done' || status === 'analysis') {
    return capitalize(status);
  }

  if (status === 'sample_pending') {
    let sampleStatus = 'Sample pending';

    if (kit.serial_number_id.sample_available) {
      sampleStatus = 'Sample received';
    }

    return `Registration pending - ${ sampleStatus }`;
  }

  if (status === 'registration_done') {
    let sampleStatus = 'Sample pending';

    if (kit.serial_number_id.sample_available) {
      sampleStatus = 'Sample received';
    }

    return `Registration done - ${ sampleStatus }`;
  }

  if (status === 'sample_received') {
    return 'Registration done - Sample received';
  }

  return kit?.registrationStatus || '';
};

const ConcentsTable = ({ consents }) => {
  const [ filterQuery, setFilterQuery ] = useState({});
  const [ monthsToDownload, setmonthsToDownload ] = React.useState(1);
  const [ monthsDoctorCustomerData, setmonthsDoctorCustomerData ] = React.useState(1);
  const [ monthsWellnessData, setmonthsWellnessData ] = React.useState(1);

  const [ selectedMonthsToDownload, setSelectedMonthsToDownload ] = useState(1);
  const [ selectedMonthsDoctorCustomerData, setSelectedMonthsDoctorCustomerData ] = useState(1);
  const [ selectedMonthsWellnessData, setSelectedMonthsWellnessData ] = useState(1);

  const handleChangeToDownload = (event) => { // Download Data
    const newSelectedMonthsToDownload = event.target.value;
    setSelectedMonthsToDownload(newSelectedMonthsToDownload);
    setmonthsToDownload(newSelectedMonthsToDownload);
  };

  const handleChangeDoctorCustomerData = (event) => { // Download Doctor/Customer Data
    const newSelectedMonthsDoctorCustomerData = event.target.value;
    setSelectedMonthsDoctorCustomerData(newSelectedMonthsDoctorCustomerData);
    setmonthsDoctorCustomerData(newSelectedMonthsDoctorCustomerData);
  };

  const handleChangeWellnessData = (event) => { // Download Wellness Data
    const newSelectedMonthsWellnessData = event.target.value;
    setSelectedMonthsWellnessData(newSelectedMonthsWellnessData);
    setmonthsWellnessData(newSelectedMonthsWellnessData);
  };

  const startDateToDownload = moment().subtract(selectedMonthsToDownload, 'months').startOf('day').toISOString();
  const startDateDoctorCustomerData = moment().subtract(selectedMonthsDoctorCustomerData, 'months').startOf('day').toISOString();
  const startDateWellnessData = moment().subtract(selectedMonthsWellnessData, 'months').startOf('day').toISOString();

  const [ downloadDataLoading, setDownloadDataLoading ] = useState(false);
  const [ downloadAllDataLoading, setDownloadAllDataLoading ] = useState(false);
  const [ downloadWellnessLoading, setDownloadWellnessLoading ] = useState(false);
  const [ selectLocation, setSelectLocation ] = useState({});
  const [ country, setCountry ] = useState('All');
  const [ light, setLight ] = useState(false);

  const handleLocation = (e) => {
    setSelectLocation(e.target.value);
    if (e.target.value === 'Albania') {
      setSelectLocation({ 'serial_number_id.country_eq': 'AL' });
    } else if (e.target.value === 'Greece') {
      setSelectLocation({ 'serial_number_id.country_eq': 'GR' });
    } else if (e.target.value === 'India') {
      setSelectLocation({ 'serial_number_id.country_eq': 'IN' });
    } else if (e.target.value === 'Iraq') {
      setSelectLocation({ 'serial_number_id.country_eq': 'IQ' });
    } else {
      setSelectLocation({});
      refetch();
    }
    setCountry(e.target.value);
  };

  const {
    items: kits,
    itemsLoading: kitsLoading,
    pagination,
    itemsFetching: kitsFetching,
    refetch,
  } = useItems(CollectionKeys.REGISTRATION_KITS, {
    filterQuery: {
      ...filterQuery,
      doctor_null: true,
      ...selectLocation,
    },
    queryOptions: { refetchOnWindowFocus: false },
  });

  const [ customerDoctorKitsLoading, setCustomerDoctorKitsLoading ] = useState(false);

  const downloadCustomerDoctorKits = (theFilterQuery) => {
    setCustomerDoctorKitsLoading(true);
    let collection = CollectionKeys.REGISTRATION_KITS;
    if (light) {
      collection = '/registration-kits/admin-find';
    }
    axiosClient.get(collection, {
      params: {
        ...theFilterQuery,
        ...selectLocation,
      },
    }).then(async (theKits) => {
      if (theKits == null || theKits.length === 0) {
        return;
      }

      const promises = theKits.map(async (kit) => {
        let addr = null;
        if (kit.customer_id != null) {
          if (kit.child == null) {
            if (typeof kit.customer_id.address === 'string') {
              addr = JSON.parse(kit.customer_id.address);
              if (addr != null) {
                addr = `${ addr.streetAddress }, ${ addr.city }, ${ addr.postalCode }`;
              }
            } else {
              addr = kit.customer_id.address;
            }
          } else if (typeof kit.child.address === 'string') {
            addr = JSON.parse(kit.child.address);
            if (addr != null) {
              addr = `${ addr.streetAddress }, ${ addr.city }, ${ addr.postalCode }`;
            }
          } else {
            addr = kit.child.address;
          }
        }

        let pdfCreation = parseDate(kit.pdf_creation);
        if (pdfCreation === '' || pdfCreation == null) {
          pdfCreation = parseDate(kit.pdf_received_date);
        }

        try {
          if (kit?.serial_number_id?.serial != null && kit?.pdf_available && (pdfCreation == null || pdfCreation === '')) {
            pdfCreation = await axiosClient.get(`/registration-kits/aws-bucket/?serial=${ kit.serial_number_id.serial }.pdf`).then((dd) => {
              return parseDate(dd.LastModified);
            });
          }
        } catch (e) {
          console.error(e);
        }

        let hasConsent = false;
        if (!light) {
          hasConsent = kit.agreements.find((aggr) => {
            return aggr?.consent?.name === 'DOCTOR_GENERAL_CONSENT' && aggr?.status === true;
          });
        }

        let obj = {
          'Serial Number': kit?.serial_number_id?.serial || '',
          Ancestor: kit?.serial_number_id?.ancestor?.serial || '',
          'Report delivery date': parseDate(kit.report_delivery_date) ?? '',
          LastName: kit.child_id == null ? kit.customer_id?.family_name : kit.child_id?.family_name,
          FirstName: kit.child_id == null ? kit.customer_id?.name : kit.child_id?.name,
          'Parent full name': kit.child_id != null ? `${ kit?.customer_id?.name } ${ kit?.customer_id?.family_name }` : '',
          'Registration done date': parseDate(kit?.metadata?.registrationDoneDate),
          'Sample received date': parseDate(kit?.metadata?.sampleReceivedDate),
          'Registration Status': getFullRegistrationStatus(kit),
          'Report paid - Kit paid': `${ kit?.serial_number_id?.report_payment_status ?? 'none' } - ${ kit?.serial_number_id?.kit_payment_status ?? 'none' }`,
          'Payment Amount': kit?.metadata?.cashAmount || '',
          'Invoice Number': kit?.metadata?.invoiceNumber || '',
          // 'Appointment Availability': kit?.appointment_availability || '',
          'Report language': kit?.locale === 3 ? 'en-US' : kit?.locale === 2 ? 'el-GR' : '' || '',
          'Report creation': kit.serial_number_id?.metadata?.['Report creation'] || '',
          'Pdf report creation date': pdfCreation,
          'Pdf received date': parseDate(kit.pdf_received_date),
          'Date of birth': kit.child_id == null ? kit.customer_id?.birthdate : kit.child_id?.birthdate,
          'Biological gender': kit.child_id == null ? kit.customer_id?.gender : kit.child_id?.gender,
          Address: addr || '',
          Country: (kit.child_id == null ? kit.customer_id?.country : kit.child_id?.country) || '',
          Email: kit.customer_id?.email || '',
          MobileNumber: kit.customer_id?.phone_number || '',
          LandlineNumber: kit.customer_id?.house_number || '',
          'Thematic package': kit?.thematic_package?.thematic_category_id?.name || '',
          'Sample collection date': parseDate(kit?.metadata?.sampleCollectionDate),
          // Description: kit.serial_number_id?.metadata?.['Product Description'] || '',
          Owner: kit?.doctor?.email || kit?.business?.email || kit.customer_id?.email || '',
          EMR: kit.serial_number_id?.metadata?.EMR || '',
          'Needs doctor consent': kit.serial_number_id?.metadata?.['Needs doctor consent'] || '',
          'Doctor full name who has been sent an invitation': kit.invitations.length > 0 ? `${ kit.invitations[0].metadata.firstName } ${ kit.invitations[0].metadata.lastName }` : '',
          'Doctor specialty who has been sent an invitation': kit.invitations.length > 0 ? kit.invitations[0].metadata.specialty : '',
          'Doctor email who has been sent an invitation': kit.invitations.length > 0 ? kit.invitations[0].metadata.email : '',
          'Doctor business number who has been sent an invitation': kit.invitations.length > 0 ? kit.invitations[0].metadata.businessNumber : '',
          'Doctor mobile number who has been sent an invitation': kit.invitations.length > 0 ? kit.invitations[0].metadata.mobileNumber : '',
          'Invitation status': kit.invitations.length > 0 ? kit.invitations[0].status : '',
        };

        if (light) {
          obj = {
            'Serial Number': kit?.serial_number_id?.serial || '',
            Ancestor: kit?.serial_number_id?.ancestor?.serial || '',
            'Report delivery date': parseDate(kit?.report_delivery_date) ?? '',
            LastName: kit?.child_id == null ? kit?.customer_id?.family_name : kit.child_id?.family_name,
            FirstName: kit?.child_id == null ? kit?.customer_id?.name : kit.child_id?.name,
            'Parent full name': kit?.child_id != null ? `${ kit?.customer_id?.name } ${ kit?.customer_id?.family_name }` : '',
            'Registration done date': parseDate(kit?.metadata?.registrationDoneDate),
            'Sample received date': parseDate(kit?.metadata?.sampleReceivedDate),
            'Registration Status': getFullRegistrationStatus(kit),
            'Report paid - Kit paid': `${ kit?.serial_number_id?.report_payment_status ?? 'none' } - ${ kit?.serial_number_id?.kit_payment_status ?? 'none' }`,
            'Report language': kit?.locale === 3 ? 'en-US' : kit?.locale === 2 ? 'el-GR' : '' || '',
            'Pdf report creation date': pdfCreation,
            'Pdf received date': parseDate(kit.pdf_received_date),
            'Date of birth': kit?.child_id == null ? kit?.customer_id?.birthdate : kit?.child_id?.birthdate,
            Address: addr || '',
            Country: (kit?.child_id == null ? kit.customer_id?.country : kit.child_id?.country) || '',
            Email: kit?.customer_id?.email || '',
            MobileNumber: kit?.customer_id?.phone_number || '',
            LandlineNumber: kit?.customer_id?.house_number || '',
            'Thematic package': kit?.thematic_package?.name || '',
            Owner: kit?.doctor?.email || kit?.business?.email || kit?.customer_id?.email || '',
            'Doctor full name who has been sent an invitation': kit?.invitations.length > 0 ? `${ kit?.invitations[0]?.metadata?.firstName } ${ kit?.invitations[0]?.metadata?.lastName }` : '',
            'Doctor specialty who has been sent an invitation': kit?.invitations.length > 0 ? kit?.invitations[0]?.metadata?.specialty : '',
            'Doctor email who has been sent an invitation': kit.invitations.length > 0 ? kit.invitations[0].metadata.email : '',
            'Invitation status': kit.invitations.length > 0 ? kit.invitations[0].status : '',

          };
        }
        if (!light) {
          consents.forEach((consent) => {
            obj[consent.name] = getConsentValue(consent, kit);
          });
        }

        obj = {
          ...obj,
          'Doctor Last Name': kit?.doctor?.family_name || '',
          'Doctor First Name': kit?.doctor?.name || '',
        };

        if (!light) {
          obj = {
            ...obj,
            'Processing of personal data': hasConsent ? 'YES' : 'NO',
          };
        }

        return obj;
      });

      const data = await limitConcurrency(promises, 15);

      // const data = await Promise.all(promises);

      const worksheet = XLSX.utils.json_to_sheet(data);
      worksheet['!cols'] = fitToColumn(data);

      function fitToColumn(arrayOfArray) {
        if (!arrayOfArray[0]) { // If file is empty
          return null;
        }
        return Object.keys(arrayOfArray[0]).map((key) => {
          return { wch: key.length };
        });
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, 'Doctor-Customer Registration Kits.xlsx');
    })
      .finally(() => {
        setCustomerDoctorKitsLoading(false);
      });
  };

  const location = useLocation();
  const history = useHistory();

  if (kitsLoading || consents === undefined || kitsFetching) {
    return <AppLoader />;
  }

  let tableColumns = [];

  tableColumns = [{ id: 1, label: 'Serial Number', field: 'serial_number_id.serial' }];
  tableColumns.push({ id: 10,
    label: 'Last name',
    field: 'customer_id.family_name',
    customRenderer({ row }) {
      return (
        <>
          {
            row.child_id == null ? `${ row.customer_id?.family_name }` : row.child_id?.family_name
          }
        </>
      );
    } });
  tableColumns.push({ id: 9,
    label: 'Name',
    field: 'customer_id.name',
    customRenderer({ row }) {
      return (
        <>
          {
            row.child_id == null ? `${ row.customer_id?.name }` : row.child_id?.name
          }
        </>
      );
    } });
  tableColumns.push({ id: 277939,
    label: 'Parent full name',
    field: 'customer_id.name',
    noSort: true,
    customRenderer({ row }) {
      return (
        <>
          {
            row.child_id != null ? `${ row.customer_id?.name } ${ row.customer_id?.family_name }` : ''
          }
        </>
      );
    } });
  tableColumns.push(
    { id: 220,
      label: 'Report delivery date',
      field: 'report_delivery_date',
      customRenderer({ row }) {
        return (
          <>
            {parseDate(row.report_delivery_date)}
          </>
        );
      } },
  );

  tableColumns.push({ id: 8, label: 'Registration done date', field: 'metadata.registrationDoneDate', isDate: true, noSort: true });
  tableColumns.push({ id: 18, label: 'Sample received date', field: 'metadata.sampleReceivedDate', isDate: true, noSort: true });
  tableColumns.push({ id: 98,
    label: 'Registration Status',
    field: 'registrationStatus',
    noSort: true,
    customRenderer({ row }) {
      return (
        <>
          {
            getFullRegistrationStatus(row)
          }
        </>
      );
    } });
  tableColumns.push({ id: 19,
    label: 'Payment Status',
    field: 'metadata.cashStatus',
    noSort: true,
    isCashStatus: true });
  tableColumns.push({ id: 20, label: 'Payment Amount', field: 'metadata.cashAmount', noSort: true });
  tableColumns.push({ id: 21, label: 'Invoice Number', field: 'metadata.invoiceNumber', noSort: true });
  // tableColumns.push({ id: 221321, label: 'Appointment Availability', field: 'appointment_availability' });
  tableColumns.push({ id: 171559,
    label: 'Report language',
    field: 'locale',
    customRenderer({ row }) {
      return (
        <>
          {
            row?.locale === 3 ? 'en-US' : row?.locale === 2 ? 'el-GR' : '' || ''
          }
        </>
      );
    } });
  tableColumns.push({ id: 7, label: 'Report creation', field: 'serial_number_id.metadata.Report creation', noSort: true });
  tableColumns.push({ id: 3174,
    label: 'Pdf report creation date',
    field: 'pdf_creation',
    isDate: true,
    customRenderer({ row }) {
      return (
        <PDFCreationFromDBOrAmazon kit={ row } />
      );
    } });
  tableColumns.push({ id: 31772, label: 'Report received date', field: 'pdf_received_date', isDate: true });
  tableColumns.push({ id: 11,
    label: 'Date of birth',
    field: 'customer_id.birthdate',
    customRenderer({ row }) {
      return (
        <>
          {
            row.child_id == null ? `${ parseDate(row.customer_id?.birthdate) }` : parseDate(row.child_id?.birthdate)
          }
        </>
      );
    } });

  tableColumns.push({ id: 12,
    label: 'Biological Gender',
    field: 'customer_id.gender',
    customRenderer({ row }) {
      return (
        <>
          {
            row.child_id == null ? `${ row.customer_id?.gender }` : row.child_id?.gender
          }
        </>
      );
    } });

  tableColumns.push({ id: 13, label: 'Address', field: 'customer_id.address', isAddress: true });
  tableColumns.push({ id: 14, label: 'Email', field: 'customer_id.email' });
  tableColumns.push({ id: 15,
    label: 'Mobile number',
    field: 'customer_id.phone_number',
    customRenderer({ row }) {
      return (
        <>
          {
            row.child_id == null ? `${ row.customer_id?.phone_number }` : row.child_id?.phone_number
          }
        </>
      );
    } });
  tableColumns.push({ id: 16,
    label: 'Landline number',
    field: 'customer_id.house_number',
    customRenderer({ row }) {
      return (
        <>
          {
            row.child_id == null ? `${ row.customer_id?.house_number }` : row.child_id?.house_number
          }
        </>
      );
    } });
  tableColumns.push({ id: 22, label: 'Sample collection date', field: 'metadata.sampleCollectionDate', noSort: true, isDate: true });
  // tableColumns.push({ id: 3, label: 'Description', field: 'serial_number_id.metadata.Product Description', noSort: true });
  tableColumns.push({ id: 5, label: 'EMR', field: 'serial_number_id.metadata.EMR', noSort: true });
  tableColumns.push({ id: 6, label: 'Needs doctor consent', field: 'serial_number_id.metadata.Needs doctor consent', noSort: true });

  let counter = 23;

  tableColumns.push(
    ...consents.map((consent) => {
      counter += 1;

      return { id: counter, label: consent.name, complex: true, noSort: true };
    }),
  );

  counter += 1;

  const _printData = async (theFilterQuery, setShowLoader) => {
    const theKits = await axiosClient.get(CollectionKeys.REGISTRATION_KITS, {
      params: {
        ...theFilterQuery,
      },
    });

    if (theKits == null) {
      setShowLoader(false);
      return;
    }

    const data = theKits.map((kit) => {
      let addr = null;
      if (kit.customer_id != null) {
        if (typeof kit.customer_id.address === 'string') {
          addr = JSON.parse(kit.customer_id.address);
          if (addr != null) {
            addr = `${ addr.streetAddress }, ${ addr.city }, ${ addr.postalCode }`;
          }
        } else {
          addr = kit.customer_id.address;
        }
      }

      const obj = {
        'Serial Number': kit.serial_number_id?.serial || '',
        LastName: kit.customer_id?.family_name || '',
        FirstName: kit.customer_id?.name || '',
        'Registration done date': parseDate(kit?.metadata?.registrationDoneDate),
        'Sample received date': parseDate(kit?.metadata?.sampleReceivedDate),
        'Registration Status': getFullRegistrationStatus(kit),
        'Report paid - Kit paid': `${ kit?.serial_number_id?.report_payment_status ?? 'none' } - ${ kit?.serial_number_id?.kit_payment_status ?? 'none' }`,
        'Payment Amount': kit?.metadata?.cashAmount || '',
        'Invoice Number': kit?.metadata?.invoiceNumber || '',
        'Report creation': kit.serial_number_id?.metadata?.['Report creation'] || '',
        'Pdf report creation date': parseDate(kit.pdf_creation),
        'Pdf received date': parseDate(kit.pdf_received_date),
        'Date of birth': kit.customer_id?.birthdate || '',
        'Biological Gender': kit.customer_id?.gender || '',
        Address: addr || '',
        Email: kit.customer_id?.email || '',
        MobileNumber: kit.customer_id?.phone_number || '',
        LandlineNumber: kit.customer_id?.house_number || '',
        'Sample collection date': parseDate(kit?.metadata?.sampleCollectionDate),
        // Description: kit.serial_number_id?.metadata?.['Product Description'] || '',
        Owner: kit.customer_id?.email || '',
        EMR: kit.serial_number_id?.metadata?.EMR || '',
        'Needs doctor consent': kit.serial_number_id?.metadata?.['Needs doctor consent'] || '',
      };

      consents.forEach((consent) => {
        obj[consent.name] = getConsentValue(consent, kit);
      });

      return obj;
    });

    const properties = [
      'Serial Number', 'Last Name', 'First Name', 'Registration done date', 'Sample received date',
      'Registration Status', 'Payment Status', 'Payment Amount', 'Invoice Number',
      'Report creation', 'Pdf report creation date', 'Pdf received date', 'Date of birth', 'Biological Gender', 'Address',
      'Email', 'Mobile Number', 'Landline Number', 'Sample collection date', 'Owner', 'EMR', 'Needs doctor consent',
      ...consents.map((consent) => { return consent.name; }),
    ];

    const doc = new jsPDF({ putOnlyUsedFonts: true, orientation: 'landscape', unit: 'mm', format: [ 100, 2050 ] });

    doc.setFont('LiberationSerif-Regular');
    doc.table(1, 1, data, properties, { autoSize: true });
    doc.save();
  };

  const downloadData = async (theFilterQuery, setShowLoader) => {
    const theKits = await axiosClient.get(CollectionKeys.REGISTRATION_KITS, {
      params: {
        ...theFilterQuery,
      },
    });

    if (theKits == null) {
      setShowLoader(false);
      return;
    }

    const data = await Promise.all(theKits.map(async (kit) => {
      let addr = null;
      if (kit.customer_id != null) {
        if (kit.child == null) {
          if (typeof kit.customer_id.address === 'string') {
            addr = JSON.parse(kit.customer_id.address);
            if (addr != null) {
              addr = `${ addr.streetAddress }, ${ addr.city }, ${ addr.postalCode }`;
            }
          } else {
            addr = kit.customer_id.address;
          }
        } else if (typeof kit.child.address === 'string') {
          addr = JSON.parse(kit.child.address);
          if (addr != null) {
            addr = `${ addr.streetAddress }, ${ addr.city }, ${ addr.postalCode }`;
          }
        } else {
          addr = kit.child.address;
        }
      }

      let pdfCreation = parseDate(kit.pdf_creation);
      if (pdfCreation === '' || pdfCreation == null) {
        pdfCreation = parseDate(kit.pdf_received_date);
      }

      try {
        if (kit.serial_number_id.serial != null && kit.pdf_available && (pdfCreation == null || pdfCreation === '')) {
          pdfCreation = await axiosClient.get(`/registration-kits/aws-bucket/?serial=${ kit.serial_number_id.serial }.pdf`).then((dd) => {
            return parseDate(dd.LastModified);
          });
        }
      } catch (e) {
        console.error(e);
      }

      const obj = {
        'Serial Number': kit.serial_number_id?.serial || '',
        'Report delivery date': parseDate(kit.report_delivery_date) ?? '',
        LastName: kit.child_id == null ? kit.customer_id?.family_name : kit.child_id?.family_name,
        FirstName: kit.child_id == null ? kit.customer_id?.name : kit.child_id?.name,
        'Parent full name': kit.child_id != null ? `${ kit.customer_id.name } ${ kit.customer_id.family_name }` : '',
        'Registration done date': parseDate(kit?.metadata?.registrationDoneDate),
        'Sample received date': parseDate(kit?.metadata?.sampleReceivedDate),
        'Registration Status': getFullRegistrationStatus(kit),
        'Report paid - Kit paid': `${ kit?.serial_number_id?.report_payment_status ?? 'none' } - ${ kit?.serial_number_id?.kit_payment_status ?? 'none' }`,
        'Payment Amount': kit?.metadata?.cashAmount || '',
        'Invoice Number': kit?.metadata?.invoiceNumber || '',
        // 'Appointment Availability': kit?.appointment_availability || '',
        'Repor language': kit?.locale === 3 ? 'en-US' : kit?.locale === 2 ? 'el-GR' : '' || '',
        'Report creation': kit.serial_number_id?.metadata?.['Report creation'] || '',
        'Pdf report creation date': pdfCreation,
        'Pdf received date': parseDate(kit.pdf_received_date),
        'Date of birth': kit.child_id == null ? kit.customer_id?.birthdate : kit.child_id?.birthdate,
        'Biological Gender': kit.child_id == null ? kit.customer_id?.gender : kit.child_id?.gender,
        Address: addr || '',
        Country: (kit.child_id == null ? kit.customer_id?.country : kit.child_id?.country) || '',
        Email: kit.customer_id?.email || '',
        MobileNumber: kit.child_id == null ? kit.customer_id?.phone_number : kit.child_id?.phone_number,
        LandlineNumber: kit.child_id == null ? kit.customer_id?.house_number : kit.child_id?.house_number,
        'Sample collection date': parseDate(kit?.metadata?.sampleCollectionDate),
        // Description: kit.serial_number_id?.metadata?.['Product Description'] || '',
        Owner: kit.customer_id?.email || '',
        EMR: kit.serial_number_id?.metadata?.EMR || '',
        'Needs doctor consent': kit.serial_number_id?.metadata?.['Needs doctor consent'] || '',
        'Doctor full name who has been sent an invitation': kit.invitations.length > 0 ? `${ kit.invitations[0].metadata.firstName } ${ kit.invitations[0].metadata.lastName }` : '',
        'Doctor specialty who has been sent an invitation': kit.invitations.length > 0 ? kit.invitations[0].metadata.specialty : '',
        'Doctor email who has been sent an invitation': kit.invitations.length > 0 ? kit.invitations[0].metadata.email : '',
        'Doctor business number who has been sent an invitation': kit.invitations.length > 0 ? kit.invitations[0].metadata.businessNumber : '',
        'Doctor mobile number who has been sent an invitation': kit.invitations.length > 0 ? kit.invitations[0].metadata.mobileNumber : '',
        'Invitation status': kit.invitations.length > 0 ? kit.invitations[0].status : '',
      };

      consents.forEach((consent) => {
        obj[consent.name] = getConsentValue(consent, kit);
      });

      return obj;
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    worksheet['!cols'] = fitToColumn(data);

    function fitToColumn(arrayOfArray) {
      if (!arrayOfArray[0]) { // If file is empty
        return null;
      }
      return Object.keys(arrayOfArray[0]).map((key) => {
        return { wch: key.length };
      });
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, 'Registration Kits.xlsx');

    setDownloadDataLoading(false);
    setDownloadAllDataLoading(false);
  };

  const downloadWellnessData = async (theFilterQuery) => {
    setDownloadWellnessLoading(true);
    const theKits = await axiosClient.get(CollectionKeys.REGISTRATION_KITS, {
      params: {
        ...theFilterQuery,
        'thematic_package.thematic_category_id.name_in': [ '3-in-1', 'Nutrition' ],
        registrationStatus_in: [ 'done' ],
      },
    });

    if (theKits == null) {
      setDownloadWellnessLoading(false);
      return;
    }

    const data = theKits.map((kit) => {
      const getValuesFromMultiQuest = (que) => {
        return que?.map((inf) => {
          if (typeof inf === 'string' || inf instanceof String) {
            return wellnessAnswersMapping[inf];
          }

          return Object.values(inf);
        })
          ?.join();
      };

      const medicalHistory = getValuesFromMultiQuest(kit.customer_id?.extra_info?.[6]);
      const farmHistory = getValuesFromMultiQuest(kit.customer_id?.extra_info?.[7]);
      const submiliHistory = getValuesFromMultiQuest(kit.customer_id?.extra_info?.[8]);

      const obj = {
        'Serial Number': kit.serial_number_id?.serial || '',
        'Date of birth': kit.customer_id?.birthdate || '',
        Gender: kit.customer_id?.gender || '',
        'Height (cm)': kit.customer_id?.extra_info?.[1] || '',
        'Weight (kg)': kit.customer_id?.extra_info?.[2] || '',
        'Are you a smoker': wellnessAnswersMapping[kit.customer_id?.extra_info?.[3]] || '',
        'If so, how many cigarettes per day?': kit.customer_id?.extra_info?.[4] || '0',
        'What is your personal goal?': wellnessAnswersMapping[kit.customer_id?.extra_info?.[5]] || '',
        'Medical History': medicalHistory || '',
        'Drug treatment': farmHistory || '',
        'Dietary supplements': submiliHistory || '',
      };

      return obj;
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    worksheet['!cols'] = fitToColumn(data);

    function fitToColumn(arrayOfArray) {
      if (!arrayOfArray[0]) { // If file is empty
        return null;
      }
      return Object.keys(arrayOfArray[0]).map((key) => {
        return { wch: key.length };
      });
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, 'Wellness Registration Kits.xlsx');

    setDownloadWellnessLoading(false);
  };

  const handleViewAction = (e, serialNumber) => {
    history.push({
      pathname: location.pathname,
      search: `?id=${ serialNumber }`,
    });
  };

  return (
    <>
      <div style={ { display: 'flex', gap: '5px', marginBottom: '15px' } }>
        <Typography
          variant='h6'
          color='secondary'
          id='location-select-label'
        >
          Country:
          {' '}
          {' '}
        </Typography>
        <div style={ { width: '150px', marginRight: '10px' } }>
          <CountrySelector
            value={ country }
            handleLocation={ handleLocation }
            all
          />
        </div>

        <LoadingButtonNoGrid
          loading={ downloadDataLoading }
          label='Download'
          onClick={ () => {
            setDownloadDataLoading(true);
            downloadData(filterQuery, setDownloadDataLoading);
          } }
          variant='contained'
          buttonStyle={ {
            marginRight: '10px',
          } }
        />

        <LoadingButtonNoGrid
          loading={ downloadAllDataLoading }
          label='Download Last'
          onClick={ () => {
            setDownloadAllDataLoading(true);
            if (selectedMonthsToDownload === 'All') {
              downloadData({ ...filterQuery, _limit: -1, doctor_null: true }, setDownloadAllDataLoading);
            } else {
              downloadData({ ...filterQuery, _limit: -1, doctor_null: true, created_at_gte: startDateToDownload }, setDownloadAllDataLoading);
            }
          } }
          variant='contained'
        />

        <MonthSelector
          selectedMonths={ monthsToDownload }
          handleChange={ handleChangeToDownload }
        />

        <div style={ { display: 'flex', gap: '5px', marginBottom: '15px' } }>
          <LoadingButtonNoGrid
            disabled={ downloadWellnessLoading }
            onClick={ () => {
              if (selectedMonthsWellnessData === 'All') {
                downloadWellnessData({ ...filterQuery });
              } else {
                downloadWellnessData({ ...filterQuery, created_at_gte: startDateWellnessData });
              }
            } }
            loading={ downloadWellnessLoading }
            variant='contained'
            label='Download Wellness Data Last'
            style={ { marginLeft: '10px' } }
          />

          <MonthSelector
            selectedMonths={ monthsWellnessData }
            handleChange={ handleChangeWellnessData }
          />

          <LoadingButton
            onClick={ () => {
              if (selectedMonthsDoctorCustomerData === 'All') {
                downloadCustomerDoctorKits({ ...filterQuery, _limit: -1 });
              } else {
                downloadCustomerDoctorKits({ ...filterQuery, _limit: -1, created_at_gte: startDateDoctorCustomerData });
              }
            } }
            loading={ customerDoctorKitsLoading }
            label='Download Doctor/Customer data Last'
            variant='contained'
            style={ { marginLeft: '10px' } }
          />

          {/* <Button
        style={ { marginRight: '10px' } }
        onClick={ () => { downloadCustomerDoctorKits(); } }
        variant='contained'
          >
           Download Doctor/Customer data
          </Button> */}

          <MonthSelector
            selectedMonths={ monthsDoctorCustomerData }
            handleChange={ handleChangeDoctorCustomerData }
          />
          <Typography variant='h6' color='secondary'>
            Full
            <Switch
              checked={ light }
              onChange={ () => { setLight(!light); } }
              color='secondary'
              name='lightdawnload'
              inputProps={ { 'aria-label': 'light download checkbox' } }
            />
            Light
          </Typography>
        </div>
      </div>
      <AppTable
        columns={ tableColumns }
        refetch={ refetch }
        data={ kits }
        loading={ kitsLoading }
        paginationProps={ pagination }
        advancedFiltersProps={ {
          properties: [
            {
              value: 'serial_number_id.serial',
              label: 'Serial Number',
              type: filterTypes.FREE_TEXT,
            },
            {
              value: 'thematic_package.thematic_category_id.name',
              label: 'Thematic Package',
              type: filterTypes.CATEGORY,
              options: [
                { value: '3-in-1', label: '3-in-1' },
                { value: 'Biological Age', label: 'Biological Age' },
                { value: 'Cardio Health', label: 'Cardio Health' },
                { value: 'NutriGenetix', label: 'NutriGenetix' },
                { value: 'Nutrition', label: 'Nutrition' },
                { value: 'PGx', label: 'PGx' },
                { value: 'Sports', label: 'Sports' },
                { value: 'Vitamins', label: 'Vitamins' },
              ],
            },
            {
              value: 'serial_number_id.id',
              label: 'Product Number',
              type: filterTypes.FREE_TEXT,
            },
            // {
            //   label: 'Description', value: 'serial_number_id.metadata.Product Description', type: filterTypes.FREE_TEXT,
            // },
            {
              label: 'Owner', value: 'customer_id.email', type: filterTypes.FREE_TEXT,
            },
            {
              label: 'EMR', value: 'serial_number_id.metadata.EMR', type: filterTypes.FREE_TEXT,
            },
            // {
            //   label: 'Needs doctor consent', value: 'serial_number_id.metadata.Needs doctor consent', type: filterTypes.FREE_TEXT,
            // },
            // {
            //   label: 'Report creation', value: 'serial_number_id.metadata.[Report creation]', type: filterTypes.FREE_TEXT,
            // },
            // {
            //   label: 'Ημερομηνία ολοκληρωσης registration', value: 'metadata.registrationDoneDate', type: filterTypes.FREE_TEXT,
            // },
            {
              label: 'First Name', value: 'customer_id.name', type: filterTypes.FREE_TEXT,
            },
            {
              label: 'Last Name', value: 'customer_id.family_name', type: filterTypes.FREE_TEXT,
            },
            {
              label: 'Date of birth', value: 'customer_id.birthdate', type: filterTypes.FREE_TEXT,
            },
            {
              label: 'Biological Gender', value: 'customer_id.gender', type: filterTypes.FREE_TEXT,
            },
            {
              label: 'Address', value: 'customer_id.address', isAddress: true, type: filterTypes.FREE_TEXT,
            },
            {
              label: 'Email', value: 'customer_id.email', type: filterTypes.FREE_TEXT,
            },
            {
              label: 'Mobile Number', value: 'customer_id.phone_number', type: filterTypes.FREE_TEXT,
            },
            {
              label: 'Landline Number', value: 'customer_id.house_number', type: filterTypes.FREE_TEXT,
            },
            {
              label: 'Registration Status ', value: 'registrationStatus', isRegistration: true, type: filterTypes.FREE_TEXT,
            },
            {
              value: 'child_id',
              label: 'Children',
              type: filterTypes.CATEGORY,
              options: [
                { value: true, label: 'False' },
                { value: false, label: 'True' },
              ],
            },
          ],
          initialAndFilterOptions: [],
          onQueryChange: setFilterQuery,
        } }
        ViewProp={ { handleView: handleViewAction } }
      />
    </>
  );
};

export default ConcentsTable;

